// extracted by mini-css-extract-plugin
export default {"component__container":"rainTable_component__container__h99o6","inner__container":"rainTable_inner__container__+msUr","section__header":"rainTable_section__header__9VBM0"};